import {BlockListItemsCard} from '@tinct/web-components';
import {useNavigate} from 'react-router-dom';

interface Campaign {
  id?: string | null;
  name?: string | null;
  status?: string | null;
  statistics?: {
    totalPagesCount?: number | null;
    visitsCount?: number | null;
  } | null;
}

interface CampaignsListProps {
  campaigns: Campaign[];
}

export function CampaignsList({campaigns}: CampaignsListProps) {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      <BlockListItemsCard
        title="Active campaigns"
        items={
          campaigns
            ?.filter(
              (campaign) =>
                campaign.status === 'published' && campaign.id && campaign.name,
            )
            .slice(0, 5)
            .map((campaign) => ({
              id: campaign.id as string,
              title: campaign.name as string,
              description: `${campaign.statistics?.totalPagesCount ?? 0} pages •  ${campaign.statistics?.visitsCount ?? 0} visits this week`,
            })) ?? []
        }
        onItemAction={(item) => navigate(`../campaigns/${item.id}`)}
        footerLabel="View all"
        onFooterClick={() => navigate('../campaigns')}
        emptyMessage="No active campaigns"
      />
      <BlockListItemsCard
        title="Draft Campaigns"
        items={
          campaigns
            ?.filter(
              (campaign) =>
                campaign.status === 'draft' && campaign.id && campaign.name,
            )
            .slice(0, 5)
            .map((campaign) => ({
              id: campaign.id as string,
              title: campaign.name as string,
              description: `${campaign.statistics?.totalPagesCount ?? 0} pages`,
            })) ?? []
        }
        footerLabel="View all"
        onItemAction={(item) => navigate(`../campaigns/${item.id}`)}
        onFooterClick={() => navigate('../campaigns')}
        emptyMessage="No draft campaigns"
      />
    </div>
  );
}
